/**
 * Check if a carousel item is a video
 */
export const isItemVideo = (item) => {
    try {
        return String(item?.mediaType?.value || '').toLowerCase() === 'video';
    } catch (e) {
        return false;
    }
};

/**
 * Get duration for a slide: if video -> null (wait for ended), otherwise use displayDuration or slide-specific value
 */
export const getSlideDuration = (item, defaultDuration) => {
    const configured = item?.displayDuration?.value || defaultDuration;
    return isItemVideo(item) ? null : Number(configured) || defaultDuration;
};
